import { useRef } from "react";
import { TextError } from "../../errors/TextError/TextError";
import "./TextArea.css";
import useAutosizeTextArea from "../../../../services/hooks/useAutosizeTextArea";

interface TextAreaProps {
  name: string;
  label?: string;
  width?: string;
  margin?: string;
  value: string;
  action: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  textError?: string;
}

export const TextArea = ({
  name,
  label,
  width,
  margin,
  value,
  action,
  textError,
}: TextAreaProps) => {
  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  useAutosizeTextArea(textAreaRef.current, value);

  const styles = {
    width: width || "20rem",
    margin: margin || "0",
  };

  return (
    <div className="textarea" style={styles}>
      {label && <label htmlFor={name}>{label}</label>}
      <textarea
        id={name}
        name={name}
        rows={1}
        ref={textAreaRef}
        value={value}
        onChange={action}
      ></textarea>
      <TextError text={textError} />
    </div>
  );
};
